import { MinusIcon, PlusIcon } from "../icons/Icons";
import LoadingIndicator from "../LoadingIndicator";
import PlanSummary from "./PlanSummary";
import { useTranslation } from "react-i18next";
import { CUSTOM_PLAN } from "../../constants/landingPage";
import InputFieldFloat from "../inputs/InputFieldFloat";

export default function BasketStep({ subscriptionPlan, quantity, setQuantity, setShowRetryValues, pricingData, isFlatPricing, setCurrentTab, couponCode, setCouponCode, onApplyCoupon, onClearCoupon, isCouponApplied, openDemoModal}) {
  const { t } = useTranslation('signup');

  if(!subscriptionPlan) {
    return <LoadingIndicator /> 
  }

  const handleIncrement = () => {
    if (subscriptionPlan?.plan_type === CUSTOM_PLAN || quantity < subscriptionPlan?.max_seats) {
      setShowRetryValues(false);
      setQuantity((prev) => prev + 1);
    }
  };

  const handleDecrement = () => {
    if (quantity > subscriptionPlan?.min_seats) {
      setShowRetryValues(false);
      setQuantity((prev) => prev - 1);
    }
  };

  return (
    <>
      {(!isFlatPricing || subscriptionPlan?.plan_type === CUSTOM_PLAN) ? (
        <div className="auth-content-right">
          <div className="auth-content-right-inner">
            <h4>{t('select_team_size')}</h4>
            <p>
              {t('select_team_size_desc')}
            </p>
            {
              subscriptionPlan?.plan_type !== CUSTOM_PLAN && (
                  <span>
                  {t('user_range', { min: subscriptionPlan.min_seats, max: subscriptionPlan.max_seats })}
                </span>
              )
            }
          </div>
          <div className="qty-update">
            <button type="button" onClick={handleDecrement} disabled={quantity <= subscriptionPlan?.min_seats}>
              <MinusIcon />
            </button>
            <InputFieldFloat
              name="quantity"
              type="text"
              className="qty-input"
              value={quantity ?? ''}
              onChange={(e) => {
                const val = parseInt(e.target.value, 10);
                setShowRetryValues(false);
                if (!isNaN(val)) {
                  setQuantity(val);
                } else if (e.target.value === '') {
                  setQuantity('');
                }
              }}
              onBlur={(e) => {
                let val = parseInt(e.target.value, 10);
                if (isNaN(val) || val < subscriptionPlan?.min_seats) {
                  val = subscriptionPlan?.min_seats;
                } else if (subscriptionPlan?.plan_type !== CUSTOM_PLAN && val > subscriptionPlan?.max_seats) {
                  val = subscriptionPlan?.max_seats;
                }
                setQuantity(val);
              }}
            />
            <button type="button" onClick={handleIncrement} disabled={subscriptionPlan?.plan_type !== CUSTOM_PLAN && quantity >= subscriptionPlan?.max_seats}>
              <PlusIcon />
            </button>
          </div>
        </div>
      ) : (
        <div className="auth-content-right">
          <div className="auth-content-right-inner">
            <h4>{t('integrated_business_plan')}</h4>
            <p>
              {t('integrated_business_plan_desc')}
            </p>
            <div className="flat-highlights">
              <ul>
                <li>{t('all_employees_up_to', { max: subscriptionPlan.max_seats })}</li>
                <li>{t('admin_dashboard')}</li>
                {subscriptionPlan.trial_days > 0 && (
                  <li>{t('trial_period', { days: subscriptionPlan.trial_days })}</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
      <PlanSummary
        planType={subscriptionPlan?.plan_type}
        couponCode={couponCode}
        setCouponCode={setCouponCode}
        pricingData={pricingData}
        isFlatPricing={isFlatPricing}
        setCurrentTab={setCurrentTab}
        quantity={quantity}
        isBasketStep={true}
        onApplyCoupon={onApplyCoupon}
        onClearCoupon={onClearCoupon}
        isCouponApplied={isCouponApplied}
        openDemoModal={openDemoModal}
      />
  </>
  )
}